/**
 * Checks if a given IP address is within a specified CIDR range.
 *
 * @param {string} ip - The IP address to check, in dotted decimal notation (e.g., "192.168.1.1").
 * @param {string} cidr - The CIDR range to check against, in the format "xxx.xxx.xxx.xxx/yy" (e.g., "192.168.1.0/24").
 * @returns A boolean indicating whether the IP address is within the CIDR range.
 */
export const isAddressInCidrRange = (ip: string, cidr: string) => {
  const [range, bits] = cidr.split('/');
  const mask = (0xffffffff << (32 - Number(bits))) >>> 0;
  const ipInt =
    ip
      .split('.')
      .reduce(
        (acc, octet, index) => acc | (parseInt(octet) << (24 - 8 * index)),
        0,
      ) >>> 0;
  const rangeInt =
    range
      .split('.')
      .reduce(
        (acc, octet, index) => acc | (parseInt(octet) << (24 - 8 * index)),
        0,
      ) >>> 0;

  return (ipInt & mask) === (rangeInt & mask);
};
